/* Site 2.2 P0 Erin PDP option guards. Never LIVE. Hide impossible radios. */
(function () {
  function root() {
    return document.querySelector('[data-mfac-erin-pdp="1"]')
      ? document.querySelector('#ProductSection-' + (document.querySelector('[data-section-type="product"]') || {}).dataset?.sectionId) || document.querySelector('.product-section') || document
      : null;
  }

  function productRoot() {
    return document.querySelector('.product-section[data-product-handle]') || document.querySelector('.product-section');
  }

  function isErinContext(pr) {
    if (!pr) return false;
    if (document.querySelector('[data-mfac-erin-pdp="1"]')) return true;
    var tags = (pr.getAttribute('data-product-tags') || '').toLowerCase();
    if (tags.indexOf('erin sabado') !== -1) return true;
    var artist = document.querySelector('.mfac-pdp-artist');
    return !!(artist && /erin sabado/i.test(artist.textContent || ''));
  }

  function selectedValue(pr, handle) {
    var wrap = pr.querySelector('.variant-input-wrap[data-handle="' + handle + '"]');
    if (!wrap) return '';
    var checked = wrap.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '';
  }

  function hideInput(el, hide) {
    if (!el) return;
    el.classList.toggle('mfac-p0-hidden', !!hide);
    el.style.display = hide ? 'none' : '';
    var input = el.querySelector('input[type="radio"]');
    if (input && hide && input.checked) {
      input.checked = false;
    }
  }

  function applyGuards(pr) {
    if (!pr || !isErinContext(pr)) return;
    var material = selectedValue(pr, 'material');
    var size = selectedValue(pr, 'image-size');
    var frameWrap = pr.querySelector('.variant-input-wrap[data-handle="frame-style"]');
    var sizeWrap = pr.querySelector('.variant-input-wrap[data-handle="image-size"]');

    if (frameWrap) {
      frameWrap.querySelectorAll('.variant-input').forEach(function (el) {
        var v = el.getAttribute('data-value') || '';
        var hide = false;
        if (/hand-touched/i.test(material)) {
          hide = !/^no frame$/i.test(v);
        } else if (/^canvas$/i.test(material)) {
          hide = /border/i.test(v) || /luxury/i.test(v) || /^deep/i.test(v);
        } else if (/^metal$/i.test(material) && /16/.test(size) && /24/.test(size)) {
          hide = /luxury/i.test(v) || (/^deep/i.test(v) && !/no frame/i.test(v) && /deep/i.test(v));
          if (/luxury/i.test(v)) hide = true;
        }
        hideInput(el, hide);
      });
      // If current frame hidden, select No Frame
      var checked = frameWrap.querySelector('input[type="radio"]:checked');
      if (!checked || (checked.closest('.variant-input') && checked.closest('.variant-input').classList.contains('mfac-p0-hidden'))) {
        var nf = Array.prototype.find.call(frameWrap.querySelectorAll('.variant-input'), function (el) {
          return /^no frame$/i.test(el.getAttribute('data-value') || '') && !el.classList.contains('mfac-p0-hidden');
        });
        if (nf) {
          var inp = nf.querySelector('input');
          if (inp) {
            inp.checked = true;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }

    if (sizeWrap && /hand-touched/i.test(material)) {
      sizeWrap.querySelectorAll('.variant-input').forEach(function (el) {
        var v = el.getAttribute('data-value') || '';
        hideInput(el, /40/.test(v) && /60/.test(v));
      });
      var sc = sizeWrap.querySelector('input[type="radio"]:checked');
      if (!sc || (sc.closest('.variant-input') && sc.closest('.variant-input').classList.contains('mfac-p0-hidden'))) {
        var prefer = Array.prototype.find.call(sizeWrap.querySelectorAll('.variant-input'), function (el) {
          return !el.classList.contains('mfac-p0-hidden');
        });
        if (prefer) {
          var inp2 = prefer.querySelector('input');
          if (inp2) {
            inp2.checked = true;
            inp2.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } else if (sizeWrap) {
      sizeWrap.querySelectorAll('.variant-input').forEach(function (el) {
        hideInput(el, false);
      });
    }
  }

  function boot() {
    var pr = productRoot();
    if (!pr) return;
    applyGuards(pr);
    pr.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[data-variant-input], input[type="radio"]')) {
        applyGuards(pr);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
